"use strict";

const tocObserver = (article) => {
	const container = article.querySelector(".content");
	const toc = article.querySelector(".toc-container");
	const chapters = container.querySelectorAll("h1");
	const headings = container.querySelectorAll("h2");
	const tocChapters = toc.querySelectorAll(".chapter");
	const tocHeadings = toc.querySelectorAll(".heading");

	const options = {
		rootMargin: "0px 0px -50% 0px",
	};

	const positionObserver = (entries, observer) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				/* if (entry.target.tagName === "H1") {
					tocChapters.forEach((chapter) => {
						const chapId = chapter.children[0].href.split("#")[1];

						chapter.classList.remove("in-view");

						if (entry.target.id === chapId) {
							chapter.classList.add("in-view");
						}
					});
				} else */ if (entry.target.tagName === "H2") {
					tocHeadings.forEach((heading) => {
						const headId = heading.children[0].href.split("#")[1];

						heading.classList.remove("in-view");

						if (entry.target.id === headId) {
							const chapter =
								headId !== "overview" ? headId.split("-")[1].split(".")[0] : null;

							heading.classList.add("in-view");

							tocChapters.forEach((chapter) => {
								chapter.classList.remove("in-view");
							});

							tocChapters[chapter - 1]?.classList.add("in-view");
						}
					});
				}
			}
		});
	};

	const observer = new IntersectionObserver(positionObserver, options);

	// chapters.forEach((chapter) => {
	// 	observer.observe(chapter);
	// });

	headings.forEach((heading) => {
		observer.observe(heading);
	});
};

export default tocObserver;
